<template>
  <div :style="containerStyle" ref="container" />
</template>

<script>
import lottie from 'lottie-web'

export default {
  name: 'LottieAnimation',
  emits: ['AnimControl'],
  props: {
    path: {
      type: String,
      required: true,
    },
    speed: {
      type: Number,
      default: 1,
    },
    width: {
      type: Number,
      default: -1,
    },
    height: {
      type: Number,
      default: -1,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoPlay: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    containerStyle() {
      return {
        width: this.width === -1 ? '100%' : `${this.width}px`,
        height: this.height === -1 ? '100%' : `${this.height}px`,
        overflow: 'hidden',
        margin: '0 auto',
      }
    },
  },
  mounted() {
    this.init()
  },
  beforeUnmount() {
    this.animation?.destroy()
  },
  methods: {
    init() {
      this.animation?.destroy()
      this.animation = lottie.loadAnimation({
        container: this.$refs.container,
        renderer: 'svg',
        loop: this.loop,
        autoplay: this.autoPlay,
        path: `/${this.path.replace(/^\/+/, '')}`,
      })
      this.animation.setSpeed(this.speed)
      this.$emit('AnimControl', this.animation)
    },
  },
  watch: {
    path() {
      this.init()
    },
  },
}
</script>
